import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfModuleAlreadyLoaded } from '../module-load-guard';
import { SpinnerComponent } from './spinner.component';
import { SpinnerService } from './spinner.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [SpinnerComponent],
  declarations: [SpinnerComponent],
  providers: [SpinnerService],
})
export class SpinnerModule {
  constructor(@Optional() @SkipSelf() parentModule: SpinnerModule) {
    throwIfModuleAlreadyLoaded(parentModule, 'SpinnerModule');
  }
}
